import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getVccSeasonData from './GetVccSeasonData';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE,
  options: []
};

const VccSeasonData = {
  INITIAL_STATE, getVccSeasonData
}

export default VccSeasonData;